import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OrderService } from '@teem/core/services/order.service';
import { LoaderService } from '@teem/core/services/loader.service';
import Swal from 'sweetalert2';
import { messages as i18n } from '@teem/constants/messages';

@Component({
  selector: 'app-scheduled',
  templateUrl: './scheduled.component.html',
  styleUrls: ['./scheduled.component.scss']
})
export class ScheduledComponent implements OnInit {
  @Output() onViewOrder: EventEmitter<any> = new EventEmitter();
  @Output() orderAction: EventEmitter<any> = new EventEmitter();

  @Input('scheduleOrders') scheduleOrders;
  @Input('remindOrders') remindOrders;

  constructor(private orderService: OrderService, private loaderService: LoaderService) {}

  ngOnInit() {
    
  }

  orderActions(action, uuid) {
    switch (action) {
      case "scheduled_read":
        this.orderAction.emit({ uuid: uuid, action: action });
        break;
    }
  }

  remindAgainAction(order: any, time) {
    this.loaderService.startLoading();
    this.orderService.action({ 'do': 'remind_again', 'uuid': order.uuid, 'time': time }).subscribe((data: any) => {
      this.loaderService.stopLoading();
      this.remindOrders = data?.remind_orders;
      this.scheduleOrders = data?.schedule_orders;
    }, err => {
      this.loaderService.stopLoading();
      Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
    });
  }

}
